import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 39);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 10 * 60);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="bg-green-600 text-white py-1 px-3 sticky top-0 z-50" data-id="element-1">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-2 text-center" data-id="element-2">
        <span className="uppercase tracking-wider text-xs font-semibold" data-id="element-3">
          ⏰ Oferta termina en:
        </span>
        <span className="text-base font-black font-mono tracking-widest" data-id="element-4">
          {formatTime(timeLeft)}
        </span>
      </div>
    </div>;
}